import styled from 'styled-components';

const AllMemberLevelStyled = styled.div`
  margin-left: 24px;
  .level-content {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 910px;
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid #dddddd;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    align-items: center;
    .all-level {
      padding-left: ${(props) => props.theme.spacing(45 / 8)};
      padding-right: ${(props) => props.theme.spacing(55 / 8)};
    }
    .forth-level {
      padding-left: ${(props) => props.theme.spacing(18 / 8)};
      padding-right: ${(props) => props.theme.spacing(20 / 8)};
    }
    div {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .status-switch {
      width: 30px;
    }
    .coupon,
    .noCoupon {
      width: 18px;
      height: 18px;
      vertical-align: middle;
      margin-right: ${(props) => props.theme.spacing(0.5)};
    }
    .coupon {
      fill: #1565c0;
    }
    .noCoupon {
      fill: #c9c9c9;
    }
    .coupons {
      background: #1565c0;
    }
    .noCoupons {
      background: #666464;
    }
    .coupon-num {
      color: #1565c0;
    }
    .noCoupon-num {
      color: #c9c9c9;
    }
    .coupon-settings {
      width: 40px !important;
      height: 28px;
      border-radius: 4px;
      font-size: 14px;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
      line-height: 28px;
      text-align: center;
      cursor: pointer;
      margin: auto;
      margin-left: ${(props) => props.theme.spacing(6 / 8)};
    }
    .MuiOutlinedInput-root {
      height: 24px !important;
      margin-right: 0 !important;
      margin: auto;
    }
    .MuiInputBase-input {
      width: 60px;
      text-align: right !important;
    }
    .basic-name {
      background: #ffffff;
      margin-right: 0 !important;
      margin: auto;
    }
  }
  .ant-switch-checked:focus {
    background: #1565c0 !important;
    box-shadow: 0 0 0 2px #1565c0 !important;
  }
  .ant-switch-checked {
    background: #1565c0 !important;
    /* border:none !important; */
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
`;

export default AllMemberLevelStyled;
